export const MODAL_STORE_KEY = 'modal';
